const baseConfig = {
    appid: '10075',
    flag1: '21763',
    flag2: '1',
};

module.exports = {
    pay: {
        ...baseConfig,
        flag3: '1',
    },
    'pay-midas': {
        ...baseConfig,
        flag3: '2',
    },
    task: {
        ...baseConfig,
        flag3: '3',
    },
    level: {
        ...baseConfig,
        flag3: '4',
    },
    privilege: {
        ...baseConfig,
        flag3: '5',
    },
    'rank-list': {
        ...baseConfig,
        flag3: '6',
    },
    'od-waiting-list': {
        ...baseConfig,
        flag3: '7',
    },
    'photo-viewer': {
        ...baseConfig,
        flag3: '8',
    },
    'second-identity-editor': {
        ...baseConfig,
        flag3: '9',
    },
    'user-profile': {
        ...baseConfig,
        flag3: '10',
    },
    'user-profile-follow': {
        ...baseConfig,
        flag3: '11',
    },
    'user-profile-followme': {
        ...baseConfig,
        flag3: '12',
    },
    'voice-cover': {
        ...baseConfig,
        flag3: '13',
    },
    'anchors-sequence': {
        ...baseConfig,
        flag3: '14',
    },
    'anchors-line-host': {
        ...baseConfig,
        flag3: '15',
    },
    'anchors-line-audience': {
        ...baseConfig,
        flag3: '16',
    },
    hall: {
        ...baseConfig,
        flag3: '17',
    },
    'pc-entry': {
        ...baseConfig,
        flag3: '18',
    },
    'phone-verfication': {
        ...baseConfig,
        flag3: '19',
    },
    'user-profile-badge-list': {
        ...baseConfig,
        flag3: '20',
    },
    'room-setting': {
        ...baseConfig,
        flag3: '21',
    },
    personal: {
        ...baseConfig,
        flag3: '22',
    },
    album: {
        ...baseConfig,
        flag3: '23',
    },
    'photo-clip': {
        ...baseConfig,
        flag3: '24',
    },
    'od-guest-rank': {
        ...baseConfig,
        flag3: '25',
    },
    'withdraw-money': {
        ...baseConfig,
        flag3: '26',
    },
    'income-list': {
        ...baseConfig,
        flag3: '27',
    },
    nobility: {
        ...baseConfig,
        flag3: '28',
    },
    'nobility-car': {
        ...baseConfig,
        flag3: '29',
    },
    relegation: {
        ...baseConfig,
        flag3: '30',
    },
    'pc-entry-hall': {
        ...baseConfig,
        flag3: '31',
    },
    'anchors-recommend-pic': {
        ...baseConfig,
        flag3: '32',
    },
    luckydraw: {
        ...baseConfig,
        flag3: '33',
    },
    'recommend-appraisal': {
        ...baseConfig,
        flag3: '34',
    },
};
